import React, { useEffect, useState } from 'react';

export const Loader: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setLoading(false), 450);
    }, 1100);
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <div
      className={`loader-overlay ${fadeOut ? 'fade-out' : ''}`}
      aria-label="Loading OCCSSG Admin"
    >
      <div className="flex flex-col items-center gap-8">
        {/* Ring wrapper */}
        <div className="relative w-24 h-24 flex items-center justify-center">
          <div className="loader-ring" />
          <div className="loader-ring-inner" />
          <img src="/logo.svg" alt="Logo" className="relative z-10 w-11 h-11" />
        </div>

        {/* Text */}
        <div className="text-center space-y-1">
          <p className="text-slate-900 font-semibold text-sm tracking-wide">
            Open Centre for Cryptography &amp; Secure System Global
          </p>
          <p className="font-devanagari text-blue-600 text-sm tracking-widest font-medium">
            रक्षणाय विज्ञानम्
          </p>
        </div>

        {/* Progress bar */}
        <div className="w-48 h-0.5 rounded-full bg-slate-200 overflow-hidden">
          <div className="loader-progress-bar h-full" />
        </div>
      </div>
    </div>
  );
};
